module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gb-wls-4abd7bc95cbecde943cceb263f8ef337.svg";